<app-realm-selector *ngIf="!isLoading"
                    (handleRealmSelection)="handleRealmSelection($event)">
</app-realm-selector>

